<script lang="ts">
  import { TableHead } from "flowbite-svelte";
</script>

<TableHead defaultRow={false}><slot /></TableHead>
